import React from "react";
import "./Navbar.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { SVG } from "sunrise-ui";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { uiActions } from "../../redux/reducers";
import { getProfileDetials } from "../../redux/reducers/profile";
import { useSelector } from "react-redux";
import Loader from "../../utilities/Loader";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    setLoading(true);
    dispatch(uiActions.setToken(""));
    sessionStorage.clear();
    navigate("/");
  };
  const profileData = useSelector((state: any) => state.PROFILE);
  const { profileDetails } = profileData;
  const { data } = profileDetails;
  React.useEffect(() => {
    !profileDetails &&
      dispatch(
        getProfileDetials({
          endPoint: "general/get-user-by-mail",
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return (
    <div className="navbar">
      <div className="navbar_wrapper d-flex w100 sb v-center">
        <div className="left_content">
          <span className="pagename fw500 ml-1">
            {location.pathname?.replace("/", "") === "change_password"
              ? "Profile"
              : location.pathname?.replace("/", "") === "master"
              ? "Master Config" //checking if page is master config
              : location.pathname?.replace("/", "") === "machine"
              ? "Machine and its Logs"
              : location.pathname?.replace("/", "")}
          </span>
        </div>
        <div className="right_content d-flex  v-center">
          <div className="notification pointer">
            <SVG type="bell" />
          </div>
          <div className="user d-flex  v-center">
            <div
              className="user_img pointer"
              aria-controls="simple-menu-navbar"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <img src={data?.userImage} alt="..." />
            </div>
            <Menu
              id="simple-menu-navbar"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate("/profile");
                }}
              >
                View Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                {loading ? (
                  <div className="pl1 p">
                    <Loader
                      color="#5f67e0"
                      loading={loading}
                      height={"auto"}
                      size={8}
                    />
                  </div>
                ) : (
                  "Logout"
                )}
              </MenuItem>
            </Menu>
            <div className="user">
              <span className="user_name capitalize">{data?.name}</span>
              <br />
              <span className="user_designation capitalize">{data?.role}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
